import { RosterContext, SettingsContext } from '../../context/context';
import { useContext, useEffect } from 'react';

import Card from 'components/layouts/card/card';
import PlayingCard from '../layouts/playing-card.js/playing-card';

function Team() {
  const { roster } = useContext(RosterContext);
  const { state, dispatch } = useContext(SettingsContext);

  useEffect(() => {
    let sections = [];
    if (roster.units.length > 0) {
      const list = [...roster.units];
      while (list.length) {
        const section = list.splice(0, state.perPage);
        sections = [...sections, section];
      }
    }
    dispatch({ type: 'sections', payload: sections})
  }, [roster, state.perPage]);

  const displayCard = () => {
    return (<section className="sheet unlimited padding-5mm">
      { roster.units.length ? roster.units.map((unit, index) => (
        <Card info={unit} key={index} />
      )) : null}
    </section>);
  }

  const displaySmallCard = () => {
    return (<section className="sheet playing-cards-sheet padding-5mm">
      { roster.units.length > 0 && roster.units.map((unit, index) => (
      <PlayingCard key={index} unit={unit} />
    )) }
    </section>);
  }

  return (
    <>{
      state.cardOrientation === 'playing-cards' ?
      displaySmallCard() : displayCard()
    }</>
  );
}

export default Team;